import {Component, OnInit, Input, Output, EventEmitter, ElementRef} from '@angular/core';
import {isNil} from 'lodash';

export interface DropdownItem {
  label: string;
  id: any;
}

@Component({
  selector: 'app-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss']
})
export class DropdownComponent implements OnInit {

  @Input() id: string;
  @Input() items: DropdownItem[];
  @Input() title: string;
  @Input() container = '';

  private selectedValue: any = null;

  width = 65;

  @Input()
  set selected(value) {
    if (!isNil(value)) {
      console.log('this.selectedValue : ', this.selectedValue);
      if (this.selectedValue) {
        this.selectedValue = value;
        const selectedItem = this.items.find((item: DropdownItem) => item.id === this.selectedValue);
        if (selectedItem) {
          this.selectedItem = selectedItem;
        }
        this.width = this.selectedValue.id === 3 ? -5 : 65;
      } else {
        this.selectedValue = value;
        const selectedItem = this.items.find((item: DropdownItem) => item.id === 1);
        if (selectedItem) {
          this.selectedItem = selectedItem;
        }
      }
    }
  }

  get selected(): any {
    return this.selectedValue;
  }

  @Output() selectedChange = new EventEmitter();
  @Output() valueChange = new EventEmitter<DropdownItem>();

  selectedItem = null;

  constructor(
    private elementRef: ElementRef
  ) {
  }

  ngOnInit(): void {
  }

  onDdlItemClick(item: DropdownItem): void {
    this.selectedItem = item;
    this.selectedChange.emit(item.id);
    this.valueChange.emit(item);
  }

  onOpen(isOpen: boolean): void {
    if (isOpen && this.container === 'body') {
      setTimeout(() => {
        const btn = this.elementRef.nativeElement.querySelector('button.dropdown-toggle');
        if (btn) {
          const width = btn.offsetWidth;
          const menu = document.querySelector('body > div div.dropdown-menu');
          if (menu) {
            (menu as any).style.width = `${ width }px`;
          }
        }
      }, 0);
    }
  }

}
